import React from 'react';
import BurgerHome from '../../images/burger-home.jpg';
import HomeBurger1 from "../../images/home-burger-1.jpg";
import HomeBurger2 from "../../images/home-burger-2.jpg";
import HomeBurger3 from "../../images/home-burger-3.jpg";
import HomeBurger4 from "../../images/home-burger-4.jpg";
import HomeBurger5 from "../../images/home-burger-5.jpg";
import HomeBurger6 from "../../images/home-burger-6.jpg";
import HomeBurger7 from "../../images/home-burger-7.jpg";
import HomeBurger8 from "../../images/home-burger-8.jpg";

const Home = () => {

    return (
        <div className="card-wrapper" style={{
            backgroundImage: `url(${BurgerHome})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundAttachment: "fixed"
        }}>
            <h2>Welcome to the Homepage</h2>
            <h3>What a delicious and tasty list of burgers!</h3>
            <ul className="list">
                <li className="card-burger">
                    <img src={HomeBurger1} alt="Home burger 1"/>
                    <p>Burger 1 - 10$</p>
                    <hr className="style-hr"/>
                    <a href="#" className="myButton">Buy it!</a>
                </li>
                <li className="card-burger">
                    <img src={HomeBurger2} alt="Home burger 1"/>
                    <p>Burger 2 - 11$</p>
                    <hr className="style-hr"/>
                    <a href="#" className="myButton">Buy it!</a>
                </li>
                <li className="card-burger">
                    <img src={HomeBurger3} alt="Home burger 1"/>
                    <p>Burger 3 - 15$</p>
                    <hr className="style-hr"/>
                    <a href="#" className="myButton">Buy it!</a>
                </li>
                <li className="card-burger">
                    <img src={HomeBurger4} alt="Home burger 1"/>
                    <p>Burger 4 - 12$</p>
                    <hr className="style-hr"/>
                    <a href="#" className="myButton">Buy it!</a>
                </li>
                <li className="card-burger">
                    <img src={HomeBurger5} alt="Home burger 1"/>
                    <p>Burger 5 - 15$</p>
                    <hr className="style-hr"/>
                    <a href="#" className="myButton">Buy it!</a>
                </li>
                <li className="card-burger">
                    <img src={HomeBurger6} alt="Home burger 1"/>
                    <p>Burger 6 - 8$</p>
                    <hr className="style-hr"/>
                    <a href="#" className="myButton">Buy it!</a>
                </li>
                <li className="card-burger">
                    <img src={HomeBurger7} alt="Home burger 1"/>
                    <p>Burger 7 - 10$</p>
                    <hr className="style-hr"/>
                    <a href="#" className="myButton">Buy it!</a>
                </li>
                <li className="card-burger">
                    <img src={HomeBurger8} alt="Home burger 1"/>
                    <p>Burger 8 - 14$</p>
                    <hr className="style-hr"/>
                    <a href="#" className="myButton">Buy it!</a>
                </li>
            </ul>
        </div>
    );
};

export default Home;
